const managerExcludeIds = ['coupons', 'bonuses'];
const moderatorExcludeIds = [
  'business_settings',
  'transaction_management',
  'report_and_analytics',
];

const filterRoutes = (routes, excludeIds) => {
  return routes
    .filter((route) => !excludeIds.includes(route.id))
    .map((route) => {
      const newRoute = { ...route };

      // Handle menus in group type routes
      if (newRoute.menus) {
        newRoute.menus = filterRoutes(newRoute.menus, excludeIds);
      }

      // Handle children in parent type routes
      if (newRoute.children) {
        newRoute.children = filterRoutes(newRoute.children, excludeIds);
      }

      return newRoute;
    });
};

const adminRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard_01',
    type: 'single',
  },

  {
    name: 'Support livreurs',
    icon: 'chat',
    url: 'support-chat',
    id: 'support_chat_01',
    type: 'single',
  },
  {
    name: 'pos.system',
    icon: 'pos',
    url: 'pos-system',
    id: 'pos.system_01',
    type: 'single',
  },
  {
    name: 'order.management',
    id: 'order_management',
    type: 'group',
    menus: [
      {
        name: 'orders',
        id: 'orders',
        icon: 'orders',
        type: 'parent',
        children: [
          {
            name: 'all',
            url: 'orders-board',
            id: 'orders-board',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'delivery.orders',
            url: 'orders-board/delivery',
            id: 'order-list-delivery',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'dine.in.orders',
            url: 'orders-board/dine_in',
            id: 'admin-orders-board-dine-in',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'pickup.orders',
            url: 'orders-board/pickup',
            id: 'order-list-pickup',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'kiosk.orders',
            url: 'orders-board/kiosk',
            id: 'order-list-kiosk',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'scheduled.orders',
            url: 'orders-board/scheduled',
            id: 'order-list-schedule',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'waiting.payment.orders',
            url: 'orders-list/waiting-payment',
            id: 'order-list-waiting-payment',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'reviews',
            url: 'reviews/order',
            id: 'order-review_01',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'refunds',
            url: 'refunds',
            id: 'refunds_02',
            type: 'single',
            parentId: 'orders',
          },
          {
            name: 'Jarvis',
            url: 'orders/jarvis',
            id: 'jarvis-dispatch',
            type: 'single',
            parentId: 'orders',
          },
        ],
      },
      {
        name: 'order.status',
        icon: 'order_statuses',
        url: 'settings/orderStatus',
        id: 'order.status',
        type: 'single',
      },
    ],
  },
  {
    name: 'shop.management',
    id: 'shop.management_04',
    type: 'group',
    menus: [
      {
        name: 'shops',
        icon: 'shops',
        url: 'shops',
        id: 'shops',
        type: 'single',
      },
      {
        name: 'shop.tags',
        icon: 'shops_tags',
        url: 'shop-tag',
        id: 'tag',
        type: 'single',
      },
      {
        name: 'shop.categories',
        icon: 'product_categories',
        url: 'catalog/shop/categories',
        id: 'shop.categories',
        type: 'single',
      },
      {
        name: 'shop.reviews',
        icon: 'reviews',
        url: 'shop-reviews',
        id: 'shop-review_01',
        type: 'single',
      },
    ],
  },
  {
    name: 'product.management',
    id: 'food.management',
    type: 'group',
    menus: [
      {
        name: 'products',
        icon: 'products',
        url: 'catalog/products',
        id: 'food',
        type: 'single',
      },
      {
        name: 'Control Product',
        icon: 'options',
        url: 'catalog/control-products',
        id: 'control-products',
        type: 'single',
      },
      {
        name: 'recepts',
        icon: 'products',
        url: 'catalog/recept',
        id: 'recept',
        type: 'single',
      },
      {
        name: 'addons',
        icon: 'addons',
        url: 'catalog/addons',
        id: 'addons',
        type: 'single',
      },
      {
        name: 'extras',
        icon: 'options',
        type: 'parent',
        id: 'extras',
        children: [
          {
            name: 'extra.group',
            url: 'catalog/extras',
            id: 'extra.group',
            type: 'single',
            parentId: 'extras',
          },
          {
            name: 'extra.value',
            url: 'catalog/extras/value',
            id: 'extra.value',
            type: 'single',
            parentId: 'extras',
          },
        ],
      },
      {
        name: 'categories',
        icon: 'product_categories',
        type: 'parent',
        id: 'parent_categories',
        children: [
          {
            name: 'product.categories',
            url: 'catalog/categories',
            id: 'categories',
            type: 'single',
            parentId: 'extras',
          },
          {
            name: 'combo.categories',
            url: 'combo-categories',
            id: 'combo.categories',
            type: 'single',
            parentId: 'extras',
          },
          {
            name: 'recipe.categories',
            url: 'catalog/recipe-categories',
            id: 'recipe.categories',
            type: 'single',
            parentId: 'extras',
          },
          {
            name: 'Website categories',
            url: 'website-categories',
            id: 'website-categories',
            type: 'single',
            parentId: 'parent_categories',
          },
        ],
      },
      {
        name: 'product.reviews',
        icon: 'reviews',
        url: 'reviews/product',
        id: 'product-review',
        type: 'single',
      },
      {
        name: 'brands',
        icon: 'careers',
        url: 'catalog/brands',
        id: 'brands',
        type: 'single',
      },
      {
        name: 'units',
        icon: 'units',
        url: 'catalog/units',
        id: 'units',
        type: 'single',
      },
    ],
  },
  {
    name: 'content.management',
    id: 'content.management',
    type: 'group',
    menus: [
      {
        name: 'career',
        icon: 'careers',
        id: 'career.list',
        type: 'parent',
        children: [
          {
            name: 'career',
            url: 'catalog/career',
            id: 'catalog.career',
            type: 'single',
            parentId: 'career.list',
          },
          {
            name: 'career.categories',
            url: 'catalog/career-categories',
            id: 'career.categories',
            type: 'single',
            parentId: 'career.list',
          },
        ],
      },
      {
        name: 'blogs',
        url: 'blogs',
        icon: 'blogs',
        id: 'blogs_02',
        type: 'single',
      },
      {
        name: 'stories',
        icon: 'stories',
        url: 'stories',
        id: 'stories',
        type: 'single',
      },
      {
        name: 'gallery',
        url: 'gallery',
        icon: 'gallery',
        id: 'gallery',
        type: 'single',
      },
    ],
  },
  {
    name: 'user.management',
    id: 'customer.management_02',
    type: 'group',
    menus: [
      {
        name: 'customers',
        icon: 'customers',
        url: 'users/user',
        id: 'user',
        type: 'single',
      },
      {
        name: 'staff.&.admin.users',
        icon: 'staff_and_admin_users',
        url: 'users/admin',
        id: 'userGroupAdd',
        type: 'single',
      },
      {
        name: 'deliverymen',
        id: 'deliverymen',
        icon: 'deliverymen',
        type: 'parent',
        children: [
          {
            name: 'deliveries.list',
            icon: 'deliveryman_list',
            id: 'deliveries_list',
            url: 'deliveries/list',
            type: 'single',
          },
          {
            name: 'deliveries.map',
            icon: 'deliveryman_map',
            id: 'deliveries_map',
            url: 'deliveries/map',
            type: 'single',
          },
          {
            name: 'delivery.statistics',
            icon: 'deliveryman_statistics',
            id: 'delivery.statistics',
            url: 'delivery/statistics',
            type: 'single',
          },
          {
            name: 'deliveryboy.reviews',
            icon: 'deliveryman_reviews',
            url: 'reviews/deliveryboy',
            id: 'deliveryboy-reviews_01',
            type: 'single',
          },
          {
            name: 'deliveryman.request',
            icon: 'deliveryman_requests',
            url: 'deliveryman/request',
            id: 'deliveryman-request_01',
            type: 'single',
          },
        ],
      },
      {
        name: 'roles',
        icon: 'wallets',
        url: 'users/role',
        id: 'userSwitch',
        type: 'single',
      },
      {
        name: 'wallets',
        icon: 'wallets',
        url: 'wallets',
        id: 'wallets_01',
        type: 'single',
      },
    ],
  },
  {
    name: 'promotion.management',
    id: 'promotion.management',
    type: 'group',
    menus: [
      {
        name: 'banners',
        icon: 'banners',
        url: 'banners',
        id: 'banners',
        type: 'single',
      },
      {
        name: 'ads',
        id: 'advert.management',
        icon: 'ads',
        type: 'parent',
        children: [
          {
            name: 'ad.list',
            id: 'ads',
            url: 'catalog/advert',
            type: 'single',
            parentId: 'advert.management',
          },
          {
            name: 'shop.ad.list',
            id: 'shop_ads',
            url: 'catalog/shop-ads',
            type: 'single',
            parentId: 'advert.management',
          },
        ],
      },
      {
        name: 'notifications',
        icon: 'notifications',
        url: 'notifications',
        id: 'notifications',
        type: 'single',
      },
      {
        name: 'cashback',
        icon: 'deliveryman_payments',
        url: 'cashback',
        id: 'cashback_01',
        type: 'single',
      },
      {
        name: 'referral',
        icon: 'referral',
        url: 'settings/referal',
        id: 'referral_02',
        type: 'single',
      },
      {
        name: 'bonus',
        icon: 'bonuses',
        url: 'bonus/list',
        id: 'bonuses',
        type: 'single',
      },
    ],
  },
  {
    name: 'transaction.management',
    id: 'transaction.management',
    type: 'group',
    menus: [
      {
        name: 'transactions',
        icon: 'transactions',
        url: 'transactions',
        id: 'transactions',
        type: 'single',
      },
      {
        name: 'seller.payments',
        icon: 'seller_payments',
        id: 'seller_payments',
        url: 'payments/sellers',
        type: 'parent',
        children: [
          {
            name: 'info',
            url: 'withdraws/seller',
            id: 'withdraws.seller_uncomplete',
            type: 'single',
            parentId: 'seller_payments',
          },
          {
            name: 'completed.payments',
            url: 'completed-withdraws/seller',
            id: 'withdraws.completed_seller_uncomplete',
            type: 'single',
            parentId: 'seller_payments',
          },
        ],
      },
      {
        name: 'deliveryman.payments',
        icon: 'deliveryman_payments',
        id: 'deliveryman_payments',
        url: 'payments/deliverymans',
        type: 'parent',
        children: [
          {
            name: 'info',
            url: 'withdraws/deliveryman',
            id: 'withdraw.deliverymans_uncomplete',
            type: 'single',
            parentId: 'deliveryman_payments',
          },
          {
            name: 'completed.payments',
            url: 'completed-withdraws/deliveryman',
            id: 'withdraw.completed_deliverymans_uncomplete',
            type: 'single',
            parentId: 'deliveryman_payments',
          },
        ],
      },
      {
        name: 'payout.requests',
        icon: 'payout_requests',
        url: 'payout-requests',
        id: 'payout_requests',
        type: 'single',
      },
      {
        name: 'payouts',
        icon: 'payouts',
        url: 'payouts',
        id: 'payouts',
        type: 'single',
      },
      {
        name: 'subscriptions',
        icon: 'subscriptions',
        url: 'subscriptions',
        id: 'subscriptions',
        type: 'single',
      },
    ],
  },
  {
    name: 'report.&.analytics',
    id: 'analytics',
    type: 'group',
    menus: [
      {
        name: 'overview',
        icon: 'overview',
        url: 'report/overview',
        id: 'report-overview',
        type: 'single',
      },
      {
        name: 'revenue',
        icon: 'revenue_reports',
        url: 'report/revenue',
        id: 'report-revenue',
        type: 'single',
      },
      {
        name: 'order',
        icon: 'order_reports',
        url: 'report/orders',
        id: 'report-orders',
        type: 'single',
      },
      {
        name: 'products',
        icon: 'product_reports',
        url: 'report/products',
        id: 'report-products',
        type: 'single',
      },
      {
        name: 'stock',
        icon: 'stock_reports',
        url: 'report/stock',
        id: 'report-stock',
        type: 'single',
      },
      {
        name: 'category.reports',
        icon: 'category_reports',
        url: 'report/categories',
        id: 'category_reports',
        type: 'single',
      },
      {
        name: 'extras.reports',
        icon: 'options_extras_reports',
        url: 'report/extras',
        id: 'options_extras_reports',
        type: 'single',
      },
    ],
  },
  {
    name: 'business.settings',
    id: 'business.settings_02',
    type: 'group',
    menus: [
      {
        name: 'general.settings',
        id: 'general_settings',
        icon: 'general_settings',
        url: 'settings/general',
        type: 'single',
      },
      {
        name: 'notification.settings',
        id: 'notification_settings',
        icon: 'notification_settings',
        type: 'parent',
        children: [
          {
            name: 'firebase.configuration',
            id: 'firebase_configuration',
            url: 'settings/firebase',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'subscriber',
            url: 'subscriber',
            id: 'subscriber',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'message.subscriber',
            url: 'message/subscriber',
            id: 'message.subscriber',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'sms.provider',
            id: 'sms_provider',
            url: 'settings/sms-payload',
            type: 'single',
            parentId: 'notification_settings',
          },
          {
            name: 'email.provider',
            id: 'email_provider',
            url: 'settings/emailProviders',
            type: 'single',
            parentId: 'notification_settings',
          },
        ],
      },
      {
        name: 'currencies',
        id: 'currencies',
        icon: 'currencies',
        url: 'currencies',
        type: 'single',
      },
      {
        name: 'payments',
        id: 'payments',
        icon: 'payments',
        type: 'parent',
        children: [
          {
            name: 'payment.methods',
            id: 'payment_methods',
            url: 'settings/payments',
            type: 'single',
            parentId: 'payments',
          },
          {
            name: 'payment.payloads',
            id: 'payment_payloads',
            url: 'payment-payloads',
            type: 'single',
            parentId: 'payments',
          },
        ],
      },
      {
        name: 'social.settings',
        id: 'social_settings',
        icon: 'social_settings',
        url: 'settings/social',
        type: 'single',
      },
      {
        name: 'app.settings',
        id: 'app_settings',
        icon: 'app_settings',
        url: 'settings/app',
        type: 'parent',
        children: [
          {
            name: 'app.settings',
            id: 'app_settings_general',
            url: 'settings/app',
            type: 'single',
            parentId: 'app_settings',
          },
          {
            name: 'App Client',
            id: 'app_settings_client',
            url: 'settings/app/client',
            type: 'single',
            parentId: 'app_settings',
          },
          {
            name: 'App Livreur',
            id: 'app_settings_livreur',
            url: 'settings/app/livreur',
            type: 'single',
            parentId: 'app_settings',
          },
        ],
      },
      {
        name: 'page.setup',
        id: 'page_setup',
        icon: 'page_setup',
        url: 'settings/faqs',
        type: 'parent',
        children: [
          {
            name: 'faq',
            id: 'faq',
            url: 'settings/faqs',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'terms.&.conditions',
            id: 'temrs_and_conditions',
            url: 'settings/terms',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'privacy.policy',
            id: 'privacy_policy',
            url: 'settings/policy',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'custom.pages',
            id: 'custom_pages',
            url: 'pages',
            type: 'single',
            parentId: 'page_setup',
          },
          {
            name: 'landing.page',
            id: 'landing_page',
            url: 'settings/landing-page',
            type: 'single',
            parentId: 'page_setup',
          },
        ],
      },
    ],
  },
  {
    name: 'system.settings',
    id: 'system.settings_01',
    type: 'group',
    menus: [
      {
        name: 'languages.&.translations',
        id: 'languages_and_translations',
        icon: 'languages_and_translations',
        type: 'parent',
        children: [
          {
            name: 'languages',
            id: 'languages',
            url: 'settings/languages',
            type: 'single',
            parentId: 'languages_and_translations',
          },
          {
            name: 'translations',
            id: 'translations',
            url: 'settings/translations',
            type: 'single',
            parentId: 'languages_and_translations',
          },
        ],
      },
      {
        name: 'backup.&.maintenance',
        id: 'backup_and_maintenance',
        icon: 'backup_and_maintenance',
        type: 'parent',
        children: [
          {
            name: 'backup',
            id: 'backup',
            url: 'settings/backup',
            type: 'single',
            parentId: 'backup_and_maintenance',
          },
          {
            name: 'clear.cash',
            id: 'clear_cash',
            url: 'settings/cashClear',
            type: 'single',
            parentId: 'backup_and_maintenance',
          },
        ],
      },
      {
        name: 'system.information',
        id: 'system_information',
        icon: 'system_information',
        url: 'settings/system-information',
        type: 'single',
      },
      {
        name: 'update.database',
        id: 'update_database',
        icon: 'update_database',
        url: 'settings/update',
        type: 'single',
      },
    ],
  },
];

const managerRoutes = filterRoutes(adminRoutes, managerExcludeIds);

const sellerRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard',
    role: 'admin',
    type: 'single',
  },
  {
    name: 'pos',
    icon: 'pos',
    url: 'seller/pos-system',
    id: 'pos',
    type: 'single',
  },
  {
    name: 'wallets',
    icon: 'wallets',
    url: 'seller/wallet',
    id: 'wallets',
    type: 'single',
  },
  {
    name: 'reservation.management',
    id: 'reservation_management',
    type: 'group',
    menus: [
      {
        name: 'reservation.list',
        icon: 'reservations.list',
        url: 'seller/bookingList',
        id: 'seller/BookingList',
        type: 'single',
      },
      {
        name: 'reservation',
        icon: 'reservations',
        url: 'seller/booking',
        id: 'seller/booking',
        type: 'single',
      },
      {
        name: 'reservation.zone',
        icon: 'reservation.zone',
        url: 'seller/booking/zone',
        id: 'seller-reservation-zone',
        type: 'single',
      },
      {
        name: 'tables.and.qrcode',
        icon: 'qrcode',
        url: 'seller/booking/tables',
        id: 'reservation-tables',
        type: 'single',
      },
      {
        name: 'reservation.time',
        icon: 'reservation.time',
        url: 'seller/booking/time',
        id: 'reservation-time',
        type: 'single',
      },
    ],
  },
  {
    name: 'order.management',
    id: 'order_management',
    type: 'group',
    menus: [
      {
        name: 'orders',
        id: 'orders',
        icon: 'orders',
        type: 'parent',
        children: [
          {
            name: 'all',
            url: 'seller/orders-board',
            id: 'orders-board',
            parentId: 'orders',
            type: 'single',
          },
          {
            name: 'dine.in.orders',
            url: 'seller/orders-board/dine_in',
            id: 'orders-board-dine-in',
            parentId: 'orders',
            type: 'single',
          },
          {
            name: 'kiosk.orders',
            url: 'seller/orders-board/kiosk',
            id: 'seller-order-list-kiosk',
            parentId: 'orders',
            type: 'single',
          },
          {
            name: 'waiting.payment.orders',
            url: 'seller/orders-list/waiting-payment',
            id: 'order-list-waiting-payment',
            parentId: 'orders',
            type: 'single',
          },
          {
            name: 'refunds',
            url: 'seller/refunds',
            id: 'refunds_01',
            parentId: 'orders',
            type: 'single',
          },
        ],
      },
      {
        name: 'reviews',
        icon: 'reviews',
        url: 'seller/reviews/order',
        id: 'order-review_01',
        type: 'single',
      },
    ],
  },
  {
    name: 'shop.management',
    id: 'shop_management',
    type: 'group',
    menus: [
      {
        name: 'my.shop',
        icon: 'my_shop',
        url: 'my-shop',
        id: 'my_shop',
        type: 'single',
      },
      {
        name: 'shop.review',
        icon: 'reviews',
        url: 'seller/shop-reviews',
        id: 'shop_reviews',
        type: 'single',
      },
      {
        name: 'branch',
        icon: 'branch',
        url: 'seller/branch',
        id: 'branch',
        type: 'single',
      },
      {
        name: 'kitchen',
        icon: 'kitchen_list',
        url: 'seller/kitchen',
        id: 'kitchen',
        type: 'single',
      },
      {
        name: 'staff.users',
        icon: 'staff_and_admin_users',
        url: 'seller/shop-users',
        id: 'staff_users',
        type: 'single',
      },
    ],
  },
  {
    name: 'product.management',
    id: 'product_management',
    type: 'group',
    menus: [
      {
        icon: 'products',
        url: 'seller/products',
        name: 'product',
        id: 'products',
        type: 'single',
      },
      {
        icon: 'products',
        url: 'seller/addons',
        name: 'addons',
        id: 'addons',
        type: 'single',
      },
      {
        name: 'recepts',
        icon: 'recept',
        url: 'seller/recept',
        id: 'recept',
        type: 'single',
      },
      {
        name: 'product.categories',
        icon: 'product_categories',
        url: 'seller/categories',
        id: 'categories',
        type: 'single',
      },
      {
        name: 'discounts',
        icon: 'discounts',
        url: 'seller/discounts',
        id: 'discounts',
        type: 'single',
      },
      {
        name: 'recipe.categories',
        icon: 'product_categories',
        url: 'seller/recipe-categories',
        id: 'recipe.categories',
        type: 'single',
      },
      {
        name: 'extras',
        id: 'options',
        icon: 'options',
        type: 'parent',
        children: [
          {
            name: 'extra.groups',
            url: 'extras',
            id: 'option_group',
            type: 'single',
            parentId: 'options',
          },
          {
            name: 'extra.values',
            url: 'extras/value',
            id: 'option_value',
            type: 'single',
            parentId: 'options',
          },
        ],
      },
      {
        name: 'product.reviews',
        id: 'product_reviews',
        icon: 'reviews',
        url: 'seller/reviews/product',
        type: 'single',
      },
    ],
  },
  {
    name: 'promotion.management',
    id: 'promotion_management',
    type: 'group',
    menus: [
      {
        name: 'coupons',
        icon: 'coupons',
        url: 'coupons',
        id: 'coupons',
        type: 'single',
      },
      {
        icon: 'bonuses',
        name: 'shop.bonus',
        url: 'seller/bonus/shop',
        id: 'bonus_shop',
        type: 'single',
      },
      {
        name: 'product.bonus',
        url: 'seller/bonus/product',
        id: 'product_bonus',
        icon: 'bonuses',
        type: 'single',
      },
    ],
  },
  {
    name: 'report.&.analytics',
    id: 'report_and_analytics',
    type: 'group',
    menus: [
      {
        name: 'order.reports',
        icon: 'order_reports',
        url: 'seller/report/orders',
        id: 'order_reports',
        type: 'single',
      },
    ],
  },
  {
    name: 'transaction',
    id: 'transaction_management',
    type: 'group',
    menus: [
      {
        name: 'payout.requests',
        icon: 'payout_requests',
        url: 'seller/withdraws',
        id: 'payout_requests',
        type: 'single',
      },
      {
        name: 'transactions',
        icon: 'transactions',
        url: 'seller/transactions',
        id: 'transactions',
        type: 'single',
      },
      {
        name: 'payouts',
        icon: 'payouts',
        url: 'seller/payouts',
        id: 'payouts',
        type: 'single',
      },
      {
        name: 'payment.payloads',
        icon: 'payments',
        id: 'payment_payloads',
        url: 'seller/payments',
        type: 'single',
      },
    ],
  },
  {
    name: 'business.settings',
    id: 'business_settings',
    type: 'group',
    menus: [
      {
        name: 'subscriptions',
        icon: 'subscriptions',
        url: 'seller/subscriptions',
        id: 'subscriptions',
        type: 'single',
      },
      {
        name: 'ad.packages',
        id: 'ad_packages',
        url: 'seller/advert',
        icon: 'ads',
        type: 'single',
      },
      {
        name: 'shop.ads',
        id: 'shop_ads',
        url: 'seller/shop-ads',
        icon: 'ad',
        type: 'single',
      },
    ],
  },
  {
    name: 'content.management',
    id: 'content_management',
    type: 'group',
    menus: [
      {
        name: 'stories',
        icon: 'stories',
        url: 'seller/stories',
        id: 'seller_stories',
        type: 'single',
      },
      {
        name: 'brands',
        icon: 'brands',
        url: 'seller/brands',
        id: 'brands',
        type: 'single',
      },
    ],
  },
];

const moderatorRoutes = filterRoutes(sellerRoutes, moderatorExcludeIds);

const deliverymanRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard',
    type: 'single',
  },
  {
    name: 'orders',
    url: 'deliveryman/orders',
    id: 'all_orders',
    type: 'single',
    icon: 'orders',
  },
  {
    name: 'payout.requests',
    icon: 'payout_requests',
    url: 'deliveryman/withdraws',
    id: 'payout_requests',
    type: 'single',
  },
];

const waiterRoutes = [
  {
    name: 'my.orders',
    icon: 'orders',
    url: 'waiter/orders-board',
    id: 'my_orders',
    type: 'single',
  },
  {
    name: 'all.orders',
    icon: 'orders',
    id: 'order_management',
    url: 'waiter/orders',
  },
];

const parcelRoutes = [
  {
    name: 'dashboard',
    icon: 'dashboard',
    url: 'dashboard',
    id: 'dashboard',
    type: 'single',
  },
  {
    name: 'order.management',
    id: 'order_management',
    type: 'group',
    menus: [
      {
        name: 'all',
        url: 'parcel-orders',
        icon: 'orders',
        id: 'all_orders',
        type: 'single',
      },
      {
        name: 'parcel.types',
        id: 'parcel_types',
        icon: 'reservations.list',
        url: 'parcel-types',
        type: 'single',
      },
      {
        name: 'options',
        id: 'options',
        icon: 'options',
        url: 'options',
        type: 'single',
      },
      {
        name: 'order.statuses',
        id: 'order_statuses',
        icon: 'order_statuses',
        url: 'settings/orderStatus',
        type: 'single',
      },
      {
        name: 'reviews',
        icon: 'reviews',
        url: 'reviews/parcel',
        id: 'order-review_01',
        type: 'single',
      },
    ],
  },
  {
    name: 'deliverymen.management',
    id: 'deliveryman.management',
    type: 'group',
    menus: [
      {
        name: 'deliveryman.list',
        id: 'deliveryman_list',
        icon: 'deliveryman_list',
        url: 'deliveries/list',
        type: 'single',
      },
      {
        name: 'deliveryman.map',
        id: 'deliveryman_map',
        icon: 'deliveryman_map',
        url: 'deliveries/map',
        type: 'single',
      },
      {
        name: 'deliveryman.statistics',
        id: 'deliveryman_statistics',
        icon: 'deliveryman_statistics',
        url: 'delivery/statistics',
        type: 'single',
      },
      {
        name: 'deliveryman.reviews',
        id: 'deliveryman_reviews',
        icon: 'deliveryman_reviews',
        url: 'reviews/deliveryboy',
        type: 'single',
      },
    ],
  },
];

export const data = {
  admin: adminRoutes,
  manager: managerRoutes,
  seller: sellerRoutes,
  moderator: moderatorRoutes,
  deliveryman: deliverymanRoutes,
  waiter: waiterRoutes,
  parcel: parcelRoutes,
};
